import { createRouter, createWebHistory } from "vue-router";
import Home from "@/pages/main-page.vue";

const routes = [
  { path: "/", component: Home },
  {
    path: "/manual",
    component: () => import("../pages/manual-page.vue"),
  },
  {
    path: "/registrasi",
    component: () => import("../pages/register/form-registrasi.vue"),
  },
  {
    path: "/ambil-antrean",
    component: () => import("../pages/ambil-antrean/ambil-antrean.vue"),
  },
  {
    path: "/lihat-antrean",
    component: () => import("../pages/informasi-antrean/lihat-antrean.vue"),
  },
  {
    path: "/pilih-puskesmas",
    component: () => import("../pages/ambil-antrean/pilih-puskesmas.vue"),
  },
  {
    path: "/pilih-poli",
    component: () => import("../pages/ambil-antrean/pilih-poli.vue"),
  },
  {
    path: "/jenis-pelayanan",
    component: () => import("../pages/jenis-pelayanan/jenis-pelayanan.vue"),
    name: "Jenis Pelayanan",
  },
  {
    path: "/informasi-antrean",
    component: () => import("../pages/informasi-antrean/informasi-antrean.vue"),
  },
  {
    path: "/telekonsultasi",
    component: () => import("../pages/telekonsultasi/cek-nik.vue"),
  },
  {
    path: "/pilih-puskesmas-telekonsultasi",
    component: () => import("../pages/telekonsultasi/pilih-faskes.vue"),
  },
  {
    path: "/ambil-antrean-telekonsultasi",
    component: () => import("../pages/telekonsultasi/ambil-antrean.vue"),
  },
  {
    path: "/waktu-layanan",
    component: () => import("../pages/waktu-layanan/waktu-layanan.vue"),
  },
  {
    path: "/tarif-layanan",
    component: () => import("../pages/tarif-layanan/tarif-layanan.vue"),
  },
  {
    path: "/pengaduan-layanan",
    component: () => import("../pages/pengaduan-layanan/pengaduan-layanan.vue"),
  },
  {
    path: "/menu-lainnya",
    component: () => import("../pages/menu-lainnya/menu-lainnya.vue"),
  },
  {
    path: "/konsultasi-psikolog",
    component: () => import("../pages/konsultasi-psikolog/cek-nik.vue"),
  },
  {
    path: "/pilih-puskesmas-psikolog",
    component: () => import("../pages/konsultasi-psikolog/pilih-psikolog.vue"),
  },
  {
    path: "/ambil-antrean-psikolog",
    component: () => import("../pages/konsultasi-psikolog/AmbilAntrean.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    to.path === "/ambil-antrean" &&
    from.path !== "/" &&
    from.path !== "/informasi-antrean"
  ) {
    router.replace("/");
  } else if (to.path === "/informasi-antrean" && from.path !== "/") {
    router.replace("/");
  } else if (to.path === "/telekonsultasi" && from.path !== "/") {
    router.replace("/");
  } else {
    next();
  }
});

export default router;
